import { useQuery } from '@tanstack/react-query';
import { ISignatureRequest } from '@clickersphere/core/entities/ISignatureRequest';
import LeadContractService from '@clickersphere/core/services/LeadContractService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const SIGNATURE_REQUESTS_QUERY_KEY = 'signature-requests';

export type SignatureRequestQueryData = WithQueryStatus<ISignatureRequest>;

export function useSignatureRequests(leadId: string, contractId: string) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: signatureRequests,
    isSuccess: isSignatureRequestsSuccess,
    isFetching: isSignatureRequestsFetching,
    isLoading: isSignatureRequestsLoading,
  } = useQuery({
    staleTime: 1000 * 60,
    enabled: !!selectedTenantId && !!leadId && !!contractId,
    queryKey: buildQueryKey([SIGNATURE_REQUESTS_QUERY_KEY, leadId, contractId]),
    queryFn: async () => {
      const result = await LeadContractService.getSignatureRequests(
        leadId,
        contractId,
      );
      return result as SignatureRequestQueryData[];
    },
    select: (data) =>
      [...data].sort(
        (a, b) =>
          new Date(b.expiresAt).getTime() - new Date(a.expiresAt).getTime(),
      ),
  });

  return {
    signatureRequests: signatureRequests ?? [],
    isSignatureRequestsSuccess,
    isSignatureRequestsFetching,
    isSignatureRequestsLoading,
  };
}
